import { render } from "./RejectConfirm.vue?vue&type=template&id=e525aea0"
import script from "./RejectConfirm.vue?vue&type=script&lang=js"
export * from "./RejectConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__